import { defineEntity, lifecycle } from './_helpers.js';

/** Scope upsert emits created or updated only. */
export default defineEntity('bigdesCurrentSituationEvaluationScope', {
    created: lifecycle(),
    updated: lifecycle(),
}, { includeDefaultLifecycle: false });
